export const getCloudinaryUrl = (url, { width, height, crop = 'fill', quality = 'auto', format = 'auto' } = {}) => {
    if (!url || !url.includes('res.cloudinary.com') || !url.includes('/upload/')) return url;

    const transforms = [`f_${format}`, `q_${quality}`];
    if (width) transforms.push(`w_${width}`);
    if (height) transforms.push(`h_${height}`);
    if (width || height) transforms.push(`c_${crop}`);

    return url.replace('/upload/', `/upload/${transforms.join(',')}/`);
};
